import React from "react";

export default function renderIcon({
  width = 21,
  height = 21,
  color = "#9ca2b8",
}) {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.542 5.5C14.7217 5.50016 18.3331 7.92914 20.0381 11.458C18.3331 14.9871 14.7218 17.4168 10.542 17.417C6.36199 17.417 2.74992 14.9872 1.04492 11.458C2.74998 7.92899 6.3621 5.5 10.542 5.5ZM10.542 6.41699C6.87538 6.41699 3.70298 8.45142 2.07129 11.458C3.70296 14.4647 6.87533 16.5 10.542 16.5C14.2085 16.4998 17.3801 14.4646 19.0117 11.458C17.3801 8.45156 14.2084 6.41715 10.542 6.41699ZM10.542 7.33301C12.8334 7.33323 14.6668 9.16663 14.667 11.458C14.667 13.7495 12.8335 15.5828 10.542 15.583C8.25033 15.583 6.41699 13.7497 6.41699 11.458C6.41717 9.16649 8.25043 7.33301 10.542 7.33301ZM10.542 8.25C9.69109 8.25 8.87414 8.58777 8.27246 9.18945C7.67093 9.79104 7.33309 10.6073 7.33301 11.458C7.33301 12.3087 7.67106 13.1249 8.27246 13.7266C8.87414 14.3282 9.69109 14.667 10.542 14.667C11.3927 14.6669 12.209 14.3281 12.8105 13.7266C13.412 13.1249 13.75 12.3087 13.75 11.458C13.7499 10.6072 13.4121 9.79105 12.8105 9.18945C12.209 8.58787 11.3927 8.25011 10.542 8.25Z"
        fill={color}
      />
    </svg>
  );
}
